/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Snapshot count for a specific vault
*/
export class VaultSnapshotCount {
  /**
  * The unique identifier of the vault
  */
  'vaultId': string;
  /**
  * Number of snapshots stored in this vault
  */
  'count': number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "count",
      "baseName": "count",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return VaultSnapshotCount.attributeTypeMap;
  }

  public constructor() {
  }
}

